import React from 'react';
import { H3, H4 } from '../Element/Heading';

type StateData = {
  [state: string]: {
    payback: number;
    cost30: string;
    kwhPerMonth: number;
    yearlySavings: number;
    residentialRate: number;
    costPerWatt: number;
  };
};
const stateData: StateData = {
  Alabama: {
    payback: 4.9,
    cost30: '$10,290',
    kwhPerMonth: 1144.77,
    yearlySavings: 2059.21,
    residentialRate: 14.51,
    costPerWatt: 2.44,
  },
  Alaska: {
    payback: 6.2,
    cost30: '$10,122',
    kwhPerMonth: 552.29,
    yearlySavings: 1607.16,
    residentialRate: 24.86,
    costPerWatt: 2.41,
  },
  Arizona: {
    payback: 5.8,
    cost30: '$10,248',
    kwhPerMonth: 1113.69,
    yearlySavings: 1748.05,
    residentialRate: 14.3,
    costPerWatt: 2.44,
  },
  Arkansas: {
    payback: 6.7,
    cost30: '$12,852',
    kwhPerMonth: 1060.04,
    yearlySavings: 1620.59,
    residentialRate: 12.31,
    costPerWatt: 3.06,
  },
  California: {
    payback: 5.8,
    cost30: '$12,012',
    kwhPerMonth: 604.91,
    yearlySavings: 1943.21,
    residentialRate: 29.78,
    costPerWatt: 2.86,
  },
  Colorado: {
    payback: 10.2,
    cost30: '$14,448',
    kwhPerMonth: 711.1,
    yearlySavings: 1239.02,
    residentialRate: 14.37,
    costPerWatt: 3.44,
  },
  Connecticut: {
    payback: 5.8,
    cost30: '$13,524',
    kwhPerMonth: 702.76,
    yearlySavings: 1970.82,
    residentialRate: 31.32,
    costPerWatt: 3.22,
  },
  Delaware: {
    payback: 7.5,
    cost30: '$11,550',
    kwhPerMonth: 934.53,
    yearlySavings: 1504.97,
    residentialRate: 16.65,
    costPerWatt: 2.75,
  },
  DistrictofColumbia: {
    payback: 11.2,
    cost30: '$11,168',
    kwhPerMonth: 630.55,
    yearlySavings: 1042.68,
    residentialRate: 17.08,
    costPerWatt: 2.75,
  },
  Florida: {
    payback: 5.4,
    cost30: '$10,836',
    kwhPerMonth: 1141.5,
    yearlySavings: 1910.87,
    residentialRate: 15.22,
    costPerWatt: 2.58,
  },
  Georgia: {
    payback: 5.6,
    cost30: '$13,440',
    kwhPerMonth: 1081.17,
    yearlySavings: 2078.44,
    residentialRate: 14.0,
    costPerWatt: 3.2,
  },
  Hawaii: {
    payback: 5.0,
    cost30: '$11,214',
    kwhPerMonth: 537.15,
    yearlySavings: 2888.36,
    residentialRate: 42.26,
    costPerWatt: 2.67,
  },
  Idaho: {
    payback: 9.8,
    cost30: '$12,306',
    kwhPerMonth: 955.28,
    yearlySavings: 1286.19,
    residentialRate: 10.79,
    costPerWatt: 2.93,
  },
  Illinois: {
    payback: 8.9,
    cost30: '$13,272',
    kwhPerMonth: 697.97,
    yearlySavings: 1391.19,
    residentialRate: 17.86,
    costPerWatt: 3.16,
  },
  Indiana: {
    payback: 6.7,
    cost30: '$15,246',
    kwhPerMonth: 938.22,
    yearlySavings: 1692.17,
    residentialRate: 15.12,
    costPerWatt: 3.63,
  },
  Iowa: {
    payback: 6.5,
    cost30: '$14,490',
    kwhPerMonth: 865.03,
    yearlySavings: 1620.37,
    residentialRate: 14.18,
    costPerWatt: 3.45,
  },
  Kansas: {
    payback: 6.3,
    cost30: '$10,038',
    kwhPerMonth: 883.18,
    yearlySavings: 1580.19,
    residentialRate: 14.09,
    costPerWatt: 2.39,
  },
  Kentucky: {
    payback: 5.7,
    cost30: '$9,828',
    kwhPerMonth: 1073.17,
    yearlySavings: 1705.05,
    residentialRate: 12.53,
    costPerWatt: 2.34,
  },

  Louisiana: {
    payback: 5.8,
    cost30: '$13,314',
    kwhPerMonth: 1200.58,
    yearlySavings: 1989.6,
    residentialRate: 11.69,
    costPerWatt: 3.17,
  },
  Maine: {
    payback: 7.6,
    cost30: '$14,490',
    kwhPerMonth: 566.83,
    yearlySavings: 1571.93,
    residentialRate: 29.26,
    costPerWatt: 3.45,
  },
  Maryland: {
    payback: 7.0,
    cost30: '$13,146',
    kwhPerMonth: 964.17,
    yearlySavings: 1652.2,
    residentialRate: 16.08,
    costPerWatt: 3.13,
  },
  Massachusetts: {
    payback: 6.9,
    cost30: '$14,868',
    kwhPerMonth: 610.26,
    yearlySavings: 1752.42,
    residentialRate: 29.01,
    costPerWatt: 3.54,
  },
  Michigan: {
    payback: 8.1,
    cost30: '$15,876',
    kwhPerMonth: 675.6,
    yearlySavings: 1461.73,
    residentialRate: 18.56,
    costPerWatt: 3.78,
  },
  Minnesota: {
    payback: 9.1,
    cost30: '$14,490',
    kwhPerMonth: 774.81,
    yearlySavings: 1408.6,
    residentialRate: 15.17,
    costPerWatt: 3.45,
  },
  Mississippi: {
    payback: 7.9,
    cost30: '$11,088',
    kwhPerMonth: 1146.33,
    yearlySavings: 1698.86,
    residentialRate: 14.09,
    costPerWatt: 2.64,
  },
  Missouri: {
    payback: 6.1,
    cost30: '$11,970',
    kwhPerMonth: 1027.74,
    yearlySavings: 1756.2,
    residentialRate: 12.46,
    costPerWatt: 2.85,
  },
  Montana: {
    payback: 10.2,
    cost30: '$10,164',
    kwhPerMonth: 858.24,
    yearlySavings: 1206.0,
    residentialRate: 12.82,
    costPerWatt: 2.42,
  },
  Nebraska: {
    payback: 8.0,
    cost30: '$11,886',
    kwhPerMonth: 1013.19,
    yearlySavings: 1462.64,
    residentialRate: 11.88,
    costPerWatt: 2.83,
  },
  Nevada: {
    payback: 7.0,
    cost30: '$10,920',
    kwhPerMonth: 970.67,
    yearlySavings: 1572.49,
    residentialRate: 17.43,
    costPerWatt: 2.6,
  },
  NewHampshire: {
    payback: 7.9,
    cost30: '$15,162',
    kwhPerMonth: 622.41,
    yearlySavings: 1629.72,
    residentialRate: 30.67,
    costPerWatt: 3.61,
  },
  NewJersey: {
    payback: 7.7,
    cost30: '$12,390',
    kwhPerMonth: 673.24,
    yearlySavings: 1390.38,
    residentialRate: 17.18,
    costPerWatt: 2.95,
  },
  NewMexico: {
    payback: 10.2,
    cost30: '$14,238',
    kwhPerMonth: 669.89,
    yearlySavings: 1213.04,
    residentialRate: 13.3,
    costPerWatt: 3.39,
  },
  NewYork: {
    payback: 7.5,
    cost30: '$14,616',
    kwhPerMonth: 599.78,
    yearlySavings: 1574.78,
    residentialRate: 20.47,
    costPerWatt: 3.48,
  },
  NorthCarolina: {
    payback: 6.9,
    cost30: '$12,768',
    kwhPerMonth: 1040.83,
    yearlySavings: 1502.54,
    residentialRate: 13.22,
    costPerWatt: 3.04,
  },
  NorthDakota: {
    payback: 6.1,
    cost30: '$10,164',
    kwhPerMonth: 1085.26,
    yearlySavings: 1633.1,
    residentialRate: 11.7,
    costPerWatt: 2.42,
  },
  Ohio: {
    payback: 6.7,
    cost30: '$12,516',
    kwhPerMonth: 888.02,
    yearlySavings: 1583.52,
    residentialRate: 15.49,
    costPerWatt: 2.98,
  },
  Oklahoma: {
    payback: 6.3,
    cost30: '$11,004',
    kwhPerMonth: 1078.2,
    yearlySavings: 1727.28,
    residentialRate: 11.83,
    costPerWatt: 2.62,
  },
  Oregon: {
    payback: 8.6,
    cost30: '$13,146',
    kwhPerMonth: 916.27,
    yearlySavings: 1290.84,
    residentialRate: 12.95,
    costPerWatt: 3.13,
  },
  Pennsylvania: {
    payback: 7.0,
    cost30: '$12,852',
    kwhPerMonth: 821.88,
    yearlySavings: 1640.14,
    residentialRate: 18.26,
    costPerWatt: 3.06,
  },
  RhodeIsland: {
    payback: 8.6,
    cost30: '$15,162',
    kwhPerMonth: 598.93,
    yearlySavings: 1397.18,
    residentialRate: 26.92,
    costPerWatt: 3.61,
  },
  SouthCarolina: {
    payback: 6.6,
    cost30: '$12,138',
    kwhPerMonth: 1080.7,
    yearlySavings: 1849.29,
    residentialRate: 14.38,
    costPerWatt: 2.89,
  },
  SouthDakota: {
    payback: 6.2,
    cost30: '$10,038',
    kwhPerMonth: 1036.73,
    yearlySavings: 1623.52,
    residentialRate: 12.99,
    costPerWatt: 2.39,
  },
  Tennessee: {
    payback: 5.6,
    cost30: '$12,474',
    kwhPerMonth: 1168.32,
    yearlySavings: 1835.2,
    residentialRate: 12.34,
    costPerWatt: 2.97,
  },
  Texas: {
    payback: 6.0,
    cost30: '$11,634',
    kwhPerMonth: 1131.93,
    yearlySavings: 1837.8,
    residentialRate: 14.49,
    costPerWatt: 2.77,
  },
  Utah: {
    payback: 10.8,
    cost30: '$11,298',
    kwhPerMonth: 768.85,
    yearlySavings: 1060.09,
    residentialRate: 10.85,
    costPerWatt: 2.69,
  },
  Vermont: {
    payback: 8.9,
    cost30: '$13,188',
    kwhPerMonth: 567.13,
    yearlySavings: 1377.45,
    residentialRate: 21.03,
    costPerWatt: 3.14,
  },
  Virginia: {
    payback: 6.2,
    cost30: '$12,768',
    kwhPerMonth: 1095.21,
    yearlySavings: 1895.15,
    residentialRate: 15.27,
    costPerWatt: 3.04,
  },
  Washington: {
    payback: 8.6,
    cost30: '$13,650',
    kwhPerMonth: 969.49,
    yearlySavings: 1212.25,
    residentialRate: 11.18,
    costPerWatt: 3.25,
  },
  WestVirginia: {
    payback: 6.3,
    cost30: '$14,700',
    kwhPerMonth: 1051.24,
    yearlySavings: 1735.81,
    residentialRate: 14.63,
    costPerWatt: 2.92,
  },
  Wisconsin: {
    payback: 10.0,
    cost30: '$12,264',
    kwhPerMonth: 694.24,
    yearlySavings: 1298.78,
    residentialRate: 17.33,
    costPerWatt: 3.41,
  },
  Wyoming: {
    payback: 8.6,
    cost30: '$10,201',
    kwhPerMonth: 869.33,
    yearlySavings: 1232.01,
    residentialRate: 11.93,
    costPerWatt: 2.57,
  },
};

interface StateFAQProps {
  state: string;
}

const StateFAQ: React.FC<StateFAQProps> = ({ state }) => {
  const stateNoSpace = state.toString().replace(/\s/g, '');
  if (!stateData[stateNoSpace]) {
    return null; // Handle the case when the state data is not available
  }

  return (
    <div>
      {' '}
      <H3>Frequently Asked Questions</H3>
      <H4>Is it worth going solar in {state}?</H4>
      <p>
        In most cases, yes, solar will save you a significant amount of money.
        Solar panels produce electricity and reduce how much power you have to
        purchase from your electric company. The typical homeowner in {state}{' '}
        pays around {stateData[stateNoSpace].residentialRate}¢ cents per
        Kilowatthour.
      </p>
      <H4>What is the payback period for solar panels in {state}?</H4>
      <p>
        Homeowners who install a solar array sized to meet 100 percent of their
        energy needs can still pay off the upfront cost in as little as 5-6
        years. The typical payback period in {state} averages{' '}
        {stateData[stateNoSpace].payback} years.
      </p>
      <H4>How much are solar panels in {state}?</H4>
      <p>
        As of August 2023, the average solar panel cost in {state} is $
        {stateData[stateNoSpace].costPerWatt}/W. Given a solar panel system size
        of 6 kilowatts (kW), an average solar installation in {state} is{' '}
        {stateData[stateNoSpace].cost30} with 30% tax credit applied.
      </p>
      <H4>What incentives are available for solar in {state}?</H4>
      <p>
        Solar installations in {state} are eligible for the 30% solar tax
        credit. Connect with us to learn more about all the local {state}{' '}
        incentives, tax credits & rebates you qualify for.
      </p>
      <p className="bold text-xs">
        ¹https://www.eaton.com/content/dam/eaton/products/backup-power-ups-surge-it-power-distribution/backup-power-ups/blackout-tracker-/blackout-tracker-annual-report-2018-mz153043en.pdf
      </p>
      <p className="bold text-xs">
        ²https://www.seia.org/solar-industry-research-data
      </p>
      <p className="bold text-xs">
        ³https://www.energy.gov/articles/4-reasons-go-solar-summer
      </p>
    </div>
  );
};

export default StateFAQ;
